module.exports = __webpack_public_path__ + "fonts/CrimsonText-Regular.28977219.eot";